import type { CategoryItem, FaqItem } from './types';

export const site = {
  name: '瓜田档案局',
  slogan: '一站在手，吃瓜不愁',
  intro:
    '瓜田档案局是一个专注「网曝黑料」类事件的整理型档案站。我们把公开流传的爆料帖、录音、聊天记录与时间线分门别类归档，标注来源与状态，让你在几分钟内看清一件事的来龙去脉。',
  email: 'hey@guatian-dangan.example.com',
  since: '2021',
  domain: 'guatian-dangan.example.com',
  disclaimer:
    '本站内容均来自公开网络传言的整理与归档，标注「网传 / 未经证实」。站内人物一律以身份代称呈现，不代表本站对其真实性的认定。',
};

export const navLinks = [
  { label: '首页', to: '/' },
  { label: '爆料合集', to: '/collections' },
  { label: '事件时间线', to: '/timeline' },
  { label: '关于我们', to: '/about' },
];

export const tickerItems = [
  '某顶流歌手录音风波出现第二版完整音频，双方各执一词',
  '带货主播刷单疑云：后台曲线与截图数据出现明显缺口',
  '企业高管群聊外泄事件持续发酵，第三方技术团队介入比对',
  '电竞选手代打传闻：官方公布训练赛原始录像时间戳',
  '练习生解约纠纷双方分别放出聊天记录，时间点存在矛盾',
  '网红恋爱时间线被粉丝逐帧拆解，取关顺序成关键证据',
];

export const categories: CategoryItem[] = [
  {
    id: 'ent',
    name: '娱乐圈',
    desc: '歌手、演员、综艺相关的爆料与回应整理',
    icon: 'ri-mic-line',
    count: 128,
  },
  {
    id: 'influencer',
    name: '网红圈',
    desc: '直播、短视频达人的数据与私德话题归档',
    icon: 'ri-live-line',
    count: 96,
  },
  {
    id: 'business',
    name: '商界',
    desc: '企业高管、创业公司内部消息的公开整理',
    icon: 'ri-briefcase-line',
    count: 54,
  },
  {
    id: 'esports',
    name: '电竞圈',
    desc: '赛事、选手、俱乐部相关争议时间线',
    icon: 'ri-gamepad-line',
    count: 47,
  },
  {
    id: 'sports',
    name: '体育圈',
    desc: '运动员场外传闻与赛程行程的核对',
    icon: 'ri-basketball-line',
    count: 38,
  },
  {
    id: 'industry',
    name: '行业观察',
    desc: '爆料生态、水军套路与信息溯源方法论',
    icon: 'ri-radar-line',
    count: 29,
  },
];

export const hotList = [
  { rank: 1, title: '某顶流歌手录音风波始末：三段音频与两次改口', slug: 'dingji-liuliang-luyin-fengbo', heat: '98.6万' },
  { rank: 2, title: '直播带货数据疑云：刷单截图与后台曲线对不上', slug: 'zhibo-daihuo-shuju-yiyun', heat: '76.2万' },
  { rank: 3, title: '某企业高管内部群聊外泄：截图来源成谜', slug: 'qiye-gaoguan-qunliao-waixie', heat: '61.4万' },
  { rank: 4, title: '电竞选手代打疑云：训练赛录像里的异常操作', slug: 'dianjing-xuanshou-daidap', heat: '52.8万' },
  { rank: 5, title: '练习生解约风波：合约条款与聊天记录的双重版本', slug: 'lianxishi-jieyue-fengbo', heat: '44.1万' },
  { rank: 6, title: '体育明星私生活传闻：一张行程表引发的连锁反应', slug: 'tiyu-mingxing-xingcheng', heat: '37.9万' },
];

export const stats = [
  { value: '392', unit: '篇', label: '已归档事件' },
  { value: '1,860', unit: '份', label: '录音与截图素材' },
  { value: '24', unit: '小时内', label: '热点跟进时效' },
  { value: '96.4', unit: '%', label: '读者认为时间线清晰' },
];

export const testimonials = [
  {
    name: '爱吃瓜的小林',
    role: '追热点三年',
    content:
      '以前一个瓜要吃一整天，各种碎片信息看得头大。现在直接看时间线，五分钟就能明白到底谁先开口、谁改了口。',
  },
  {
    name: '阿哲',
    role: '内容运营',
    content:
      '最欣赏的是它会把「存疑」「待核实」标出来，不硬下结论。做选题参考的时候省了大量溯源时间。',
  },
  {
    name: 'Momo',
    role: '普通读者',
    content:
      '合集帖太香了，同一类话题一次看完。录音和聊天记录也按顺序打包好，不用满地找资源。',
  },
];

export const faqs: FaqItem[] = [
  {
    question: '瓜田档案局的内容是怎么整理的？',
    answer:
      '我们只做公开信息的整理：先锁定爆料源头帖，再按时间顺序收集各方的回应、录音、截图与媒体报道，交叉比对后写成时间线，并标注每一条素材的来源与核实状态。',
  },
  {
    question: '为什么站内人物都用「某歌手」「某高管」这样的代称？',
    answer:
      '因为多数事件在整理时仍未尘埃落定。用身份代称可以避免把未经证实的信息指向具体个人，也方便读者专注于事件本身的时间逻辑，而不是被名字带节奏。',
  },
  {
    question: '「存疑」「待核实」这些标签是什么意思？',
    answer:
      '「已归档」表示素材有可查的公开出处；「存疑」表示素材本身存在剪辑、拼接或用词不一致的疑点；「待核实」表示我们暂时找不到第二方独立信源。标签只是整理状态的提示，不是结论。',
  },
  {
    question: '事件后续出现反转，旧内容会更新吗？',
    answer:
      '会。每条档案都维护一条时间线，新进展会以补充条目的方式追加在末尾，并在标题旁更新状态标签，比如从「持续发酵」变成「已反转」，旧内容不会悄悄删改。',
  },
  {
    question: '可以投稿或指正档案里的错误吗？',
    answer:
      '非常欢迎。如果你手上有更完整的公开素材，或发现时间线里的时间点、引用有误，可以通过页脚的邮箱联系我们，注明具体条目和时间点，我们会逐条核对后更新。',
  },
  {
    question: '这里会发布无法公开来源的私密信息吗？',
    answer:
      '不会。本站只收录已经在公开网络上流传、可被追溯的内容，不接收也不发布任何涉及个人隐私、联系方式或未公开私密资料的信息。',
  },
];